module.exports = __webpack_public_path__ + "static/media/S2ME.e6890671.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/S2ME.jpg
// module id = 91
// module chunks = 0